
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/returns/how-to-return-your-item",
      function () {
        return require("private-next-pages/returns/how-to-return-your-item/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/returns/how-to-return-your-item"])
      });
    }
  